export const blockRank = (block) => {
  const rank = Number(block?.rank);
  return Number.isFinite(rank) ? rank : 0;
};

export const hasBlockRank = (block) =>
  block?.rank != null && Number.isFinite(Number(block.rank));

export const sortAnalysisBlocks = (blocks = []) => [...blocks].sort((a, b) => {
  const rankDifference = blockRank(b) - blockRank(a);
  if (rankDifference !== 0) return rankDifference;
  return Number(b?.timestamp || 0) - Number(a?.timestamp || 0);
});

export const nextRankAfterBlocks = (currentNextRank = 1, blocks = []) => {
  const highestRank = blocks.reduce(
    (highest, block) => Math.max(highest, blockRank(block)),
    0
  );
  return Math.max(Number(currentNextRank) || 1, highestRank + 1);
};

export const allocateTopBlockRanks = (nextRank = 1, count = 1) => {
  const safeNextRank = Math.max(1, Number(nextRank) || 1);
  const safeCount = Math.max(0, Math.floor(Number(count) || 0));
  return {
    ranks: Array.from(
      { length: safeCount },
      (_, index) => safeNextRank + safeCount - index - 1
    ),
    nextRank: safeNextRank + safeCount,
  };
};

export const prepareRankedAnalysisBlocks = (blocks = [], currentNextRank = 1) => {
  const rankedBlocks = blocks.filter(hasBlockRank);
  const unrankedBlocks = blocks
    .filter((block) => !hasBlockRank(block))
    .sort((a, b) => Number(b?.timestamp || 0) - Number(a?.timestamp || 0));
  const firstAvailableRank = nextRankAfterBlocks(currentNextRank, rankedBlocks);
  const allocation = allocateTopBlockRanks(firstAvailableRank, unrankedBlocks.length);
  const migrations = unrankedBlocks.map((block, index) => ({
    id: String(block.id),
    rank: allocation.ranks[index],
  }));
  const migratedRankById = new Map(
    migrations.map(({ id, rank }) => [id, rank])
  );
  const blocksWithRanks = blocks.map((block) => {
    const rank = migratedRankById.get(String(block.id));
    return rank == null ? block : { ...block, rank };
  });

  return {
    blocks: sortAnalysisBlocks(blocksWithRanks),
    migrations,
    nextRank: allocation.nextRank,
  };
};
